export default function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-interpolate/src/quantize.js
// module id = 334
// module chunks = 0 1 2 3 4